import { render } from "./ChatbotStep2.vue?vue&type=template&id=0bdd3299&scoped=true"
import script from "./ChatbotStep2.vue?vue&type=script&lang=js"
export * from "./ChatbotStep2.vue?vue&type=script&lang=js"

import "./ChatbotStep2.vue?vue&type=style&index=0&id=0bdd3299&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdd3299"]])

export default __exports__